import React, { useState } from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { DropDownList } from '@/components/dropDownList'
import { ModalBody, Form, FormGroup, Label } from 'reactstrap'
import Resx from '@/components/Resx'

function ExportPdfDialog (props) {
  const paperSizes = ['A4', 'A3', 'A2', 'A1', 'A0']
  const fontSizes = [8, 9, 10, 11, 12]
  const [paperSize, setPaperSize] = useState('A4')
  const [fontSize, setFontSize] = useState(8)

  return (
    <React.Fragment>
      <BasicHeader title='Common.PdfExportDetails' {...props} />
      <ModalBody>
        <Form>
          <FormGroup>
            <Label><Resx name='Common.PaperSize' /></Label>
            <DropDownList data={paperSizes} defaultItem={paperSize} onChange={({ value }) => setPaperSize(value)} value={paperSize} />
          </FormGroup>
          <FormGroup>
            <Label><Resx name='Common.FontSize' /></Label>
            <DropDownList data={fontSizes} defaultItem={fontSize} onChange={({ value }) => setFontSize(value)} value={fontSize} />
          </FormGroup>
        </Form>
      </ModalBody>
      <ConfirmFooter primaryButtonText='Common.ExportToPdf' icon='bxs-file-pdf' {...props} onAction={() => props.onAction({ fontSize, paperSize })} />
    </React.Fragment>
  )
}

export default {
  component: ExportPdfDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/exportPdf.js